import React, { useEffect, useState } from 'react'
import { BaseConfig } from '../../../../components/BaseConfig';
import Button2 from '../../../../components/general/button2';
import { TextHtmlTagType, generalAudioCaching, getGlobalTextSizeStyle } from '../../../../misc/tools';
import Tools from '../../../Misc/Tools';
import { PreCacheItem, SinglePreCacheItem, PrecacheItemType } from '../../../pre-caching/pre-cache-item';
import { UIProperties } from '../UIProperties';
import CoreArrow1 from './core-arrow1';
import CorePopUp from './core-pop-up';

import "./core-resume-ui.css"
import { constants } from '../../../../misc/constants';

class CoreResumeUICaching extends PreCacheItem {
	public getItems(): SinglePreCacheItem[] {
		return [
			{
				type: PrecacheItemType.Image,
				key: 'ref-mats',
				src: process.env.PUBLIC_URL + '/assets/images/main-menu/reference-materials.svg'
			}
		];
	}
}

export const coreResumeUICaching = new CoreResumeUICaching();

const CoreResumeUI = (props: UIProperties<CoreResumeUIConfig>) => {
	const [isInit, setIsInit] = useState(false);
	useEffect(() => {
		if(!isInit) {
			setIsInit(true);

			const url = generalAudioCaching.getItemByKey(generalAudioCaching.audioKeys.chime_bell_ding_01).src;
			Tools.playOneShotSound(url);
		}
	}, []);
	return (
		<div className="modal-disable-select center-element resume-ui-container" style={{
		}}>
			<CorePopUp title='Resume:' onRenderContent={() => {
				return (
					<div className='resume-ui-content'>
						<p className='default-text' style={{textAlign: 'center', ...getGlobalTextSizeStyle(TextHtmlTagType.p)}}>
							It looks like you have a previous session for this scenario, would you like to resume or start a new game?
							<br />
							If you start a new game the previous session will not be available again.
						</p>
						<div className='resume-ui-content-cancel-bttn-container'>
							<Button2 width= '100%'
								height= '100%'
								hoverBgColor={constants.design.hoverColor1}
								onClick= {() => {}}
								onRenderContent= {() => {
									return (
										<div className='resume-ui-content-btn center-element'>
											<img className='resume-ui-content-btn-img' src={coreResumeUICaching.getItemByKey('ref-mats').src} />
											<p style={{...getGlobalTextSizeStyle(TextHtmlTagType.p)}}className='small-text resume-ui-content-btn-text'>Resume Game</p>
										</div>
									)
								}}
								isSelected= {false}
								ariaLabel= 'Return to Previous Menu'></Button2>
						</div>
						<div className='resume-ui-content-confirm-bttn-container'>
							<Button2 width= '100%'
								height= '100%'
								hoverBgColor={constants.design.hoverColor1}
								onClick= {() => {}}
								onRenderContent= {() => {
									return (
										<div>
											<p style={{...getGlobalTextSizeStyle(TextHtmlTagType.p)}}className='small-text resume-ui-content-btn-confirm-text center-element-vertical'>New Game</p>
											<div className='resume-ui-content-arrow center-element-vertical'>
												<CoreArrow1></CoreArrow1>
											</div>
										</div>
									)
								}}
								isSelected= {false}
								ariaLabel= 'Return to Previous Menu'></Button2>
						</div>
					</div>
				);
			}}></CorePopUp>

		</div>
	);

};

export interface CoreResumeUIConfig extends BaseConfig {
}

export default CoreResumeUI;